import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Function to scroll to the top
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // Smooth scrolling
      });
    };

    // Scroll to top when the path changes
    scrollToTop();

    // Add event listener for navbar links
    const handleNavClick = (event) => {
      const target = event.target.closest('a'); // Assuming your navbar links are <a> elements
      if (target) {
        scrollToTop();
      }
    };

    // Attach the event listener to the document
    document.addEventListener('click', handleNavClick);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleNavClick);
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;
